<!-- @veltra/icons generated sha256:29a7fe26c22f7da1 gen:8 source:src/svg/normal/right.svg -->
<script setup lang="ts">
defineOptions({ name: 'Right' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M12.086 7.5 8.788 4.203a.5.5 0 0 1 .016-.713.487.487 0 0 1 .695.01l4.284 4.284a.31.31 0 0 1 0 .433L9.5 12.5a.5.5 0 0 1-.709-.004.496.496 0 0 1-.002-.7L12.086 8.5H2.502A.505.505 0 0 1 2 7.996v-.011a.49.49 0 0 1 .502-.485z"
    />
  </svg>
</template>
